import { Block } from "@components/block";
import { Blured } from "@components/blured";
import { ChartFilter } from "@components/chart-filter";
import { ProfitChart, ProfitFilterType } from "@components/profit-chart";
import { formatUsdt } from "@helpers/format";
import classNames from "classnames";
import { useState } from "react";
import styles from "./profit.module.scss";

type Props = {
  className?: string;
  profit: number;
};

export const ProfitSmall = ({ className, profit }: Props) => {
  const [filter, setFilter] = useState<ProfitFilterType>("week");

  return (
    <Block className={classNames(styles.card, className)}>
      <Blured className={styles.blured}>
        <div className={styles.header}>
          <h3>Оборот</h3>
          <ChartFilter
            type={filter}
            setType={setFilter}
            className={styles.filter}
          />
        </div>
        <p className={styles.profit}>{formatUsdt(profit)}</p>
      </Blured>
      <ProfitChart type={filter} />
    </Block>
  );
};
